<template>
  <div class="question-container">
    <!-- VIEW MODE -->
    <div v-if="mode == 0">
      <div class="row">
        <div class="col-md-12 d-flex pl-0">
          <span class="index-no" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>

          <div class="question" v-if="activityType == 'activity'">
            <div class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="question.formattedTitle"></div>
            <div class="question-text" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></div>
          </div>

          <div class="question" v-else>
            <div class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></div>
            <div class="question-text" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- EDIT MODE -->
    <div v-if="mode == 1">
      <div class="row">
        <div class="col-md-12 d-flex pl-0">
          <span class="index-no" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>

          <div class="question" v-if="activityType == 'activity'">
            <div class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="question.formattedTitle"></div>
            <div class="question-text" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></div>
          </div>

          <div class="question" v-else>
            <div class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></div>
            <div class="question-text" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- PREVIEW MODE -->
    <div v-else-if="mode == 2">
      <div class="row">
        <div class="col-md-12 d-flex pl-0">
          <span class="index-no" v-if="surveyData.showNumericLabels || surveyData.showNumericLabels == undefined || surveyData.showNumericLabels == null">{{ stepNo }}.</span>

          <div class="question" v-if="activityType == 'activity'">
            <div class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="question.formattedTitle"></div>
            <div class="question-text" v-else v-html="question.formattedTitle"></div>
          </div>

          <div class="question" v-else>
            <div>
              <div class="question-text" v-if="selectedLanguageCulture == 'EN'" v-html="answer[usage.QUESTION_TEXT]"></div>
              <div class="question-text" v-else v-html="answer[usage.DISPLAY_QUESTION_TEXT]"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import activityCommonMixin from "./activity-common-mixin";
export default {
  name: "InstructionResponse",
  mixins: [activityCommonMixin],
  props: {
    mode: Number,
    answer: Object,
    question: Object,
    selectedLanguageCulture: String,
    stepIndex: Number,
    usage: Object,
    surveyData: Object,
    activityType: String
  }
};
</script>
